import React, { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { Grid, Box, Chip } from '@material-ui/core'
import { components, useServices, useTranslation } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import BillingConfigKeys from 'src/constants/locale/key/BillingConfig'
import TprApiUrls from '../../apiUrls/TprApiUrls'

const {
  form: {
    field: {
      CngTextField,
      CngSelectField, 
    },
  },
  CngGridItem,
} = components

const DEFAULT_INITIAL_VALUES = Object.freeze({
  partyName: "",  
  partyIds: null,  
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
}

function Fields({
  disabled,
  shouldHideMap,
  partyIds,
  partyName,
}) {
  const { translate } = useTranslation([Namespace.UI_COMPONENT, Namespace.BILLING_CONFIG])
  const { setValue, getValues } = useFormContext()
  const { securedSendRequest } = useServices()

  const [partyList, setPartyList] = useState([]) 
  const [selectedPartyId, setSelectedPartyId] = useState(partyIds || null)  

  function fetchAllParty() {
    function onSuccess(response) {
      const content = response.data.content
      const partyData = content.map(e => ({
        text: e.name, 
        value: e.id,
      }))
      setPartyList(partyData) 
    }

    function onError(error) {
      console.error(error)
    }

    securedSendRequest.execute('POST', TprApiUrls.GET, {}, onSuccess, onError)
  }

  useEffect(() => {
    fetchAllParty() 
  }, [])

  useEffect(() => {
    if (partyList.length > 0 && partyName) {
      const selectedParty = partyList.find(party => party.text === partyName && party.value===partyIds)
      if (selectedParty) {
        setSelectedPartyId(selectedParty.value)  
        setValue('partyIds', selectedParty.value, { shouldValidate: true })
        setValue('partyName', selectedParty.text, { shouldValidate: true })
      }
    }
  }, [partyList, partyName]) 

  const partyChangeHandler = (event) => {
    const selectedPartyId = event.target.value
    setSelectedPartyId(selectedPartyId) 

    const selectedParty = partyList.find(party => party.value === selectedPartyId)
    if (selectedParty) {
      setValue("partyIds", selectedParty.value, { shouldValidate: true })
      setValue("partyName", selectedParty.text, { shouldValidate: true })
    }
  }

  function makeTranslatedTextsObject() {
    return {
      partyName: translate(Namespace.BILLING_CONFIG, BillingConfigKeys.PARTY_NAME),
      partyIds: translate(Namespace.BILLING_CONFIG, BillingConfigKeys.PARTY_ID),
    }
  }

  const translatedTextsObject = makeTranslatedTextsObject()

  return (
    <Grid container spacing={3}>
      <CngGridItem sm={12} md={6} shouldHide={shouldHideMap.partyName}>
        <CngSelectField
          name="partyIds"  
          label={translatedTextsObject.partyName}
          items={partyList.map(party => ({
            text: party.text,  
            value: party.value,  
          }))} 
          value={selectedPartyId}  
          onChange={partyChangeHandler} 
          SelectProps={{
            multiple: false, 
            renderValue: (selected) => {
              const selectedParty = partyList.find(party => party.value === selected)
              return (
                <Box style={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {selectedParty && (
                    <Chip key={selectedParty.value} label={selectedParty.text || ""} /> 
                  )}
                </Box>
              )
            },
          }}
        />
      </CngGridItem>
    </Grid>
  )
}

const BillingPartyFormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields,
})

export default BillingPartyFormProperties
